export default __webpack_public_path__ + "static/media/64.3e32a52e.png";